import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const CallOutgoing = () => (
  <ImageIcon src={Images.CallOutgoing} alt="Call Outgoing" />
);

export default CallOutgoing;
